import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import YSVLogo from "@/components/YSVLogo";
import { Menu, X } from "lucide-react";

const navLinks = [
  { label: "Features", path: "/features" },
  { label: "Pricing", path: "/pricing" },
  { label: "Support", path: "/support" },
];

const Navbar = () => {
  const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <nav data-testid="navbar" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: 100,
      background: 'rgba(10, 10, 12, 0.85)',
      backdropFilter: 'blur(16px)',
      WebkitBackdropFilter: 'blur(16px)',
      borderBottom: '1px solid var(--dark-border)',
    }}>
      <div style={{
        maxWidth: 1200,
        margin: '0 auto',
        padding: '0 24px',
        height: 64,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}>
        {/* Logo */}
        <Link to="/landing" data-testid="nav-logo" style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          textDecoration: 'none',
        }}>
          <YSVLogo size="sm" />
        </Link>

        {/* Desktop Links */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 32,
        }} className="desktop-nav">
          {navLinks.map(link => (
            <Link
              key={link.path}
              to={link.path}
              data-testid={`nav-${link.label.toLowerCase()}`}
              className={location.pathname === link.path ? 'nav-link-active' : ''}
              style={{
                textDecoration: 'none',
                color: location.pathname === link.path ? 'var(--cyan)' : 'var(--text-secondary)',
                fontSize: 14,
                fontWeight: 500,
                transition: 'color 0.2s ease',
              }}
              onMouseEnter={e => { if (location.pathname !== link.path) e.target.style.color = 'var(--text-primary)'; }}
              onMouseLeave={e => { if (location.pathname !== link.path) e.target.style.color = 'var(--text-secondary)'; }}
            >
              {link.label}
            </Link>
          ))}

          <Link to="/sign-in" data-testid="nav-signin" style={{
            textDecoration: 'none',
            color: 'var(--text-primary)',
            fontSize: 14,
            fontWeight: 600,
            transition: 'color 0.2s ease',
          }}
            onMouseEnter={e => e.target.style.color = 'var(--cyan)'}
            onMouseLeave={e => e.target.style.color = 'var(--text-primary)'}
          >
            Sign In
          </Link>

          <Link to="/get-started" data-testid="nav-get-started" className="btn-primary" style={{
            textDecoration: 'none',
            padding: '8px 20px',
            fontSize: 14,
            borderRadius: 6,
            display: 'inline-block',
          }}>
            Get Started
          </Link>
        </div>

        {/* Mobile menu toggle */}
        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setMobileOpen(!mobileOpen)}
          style={{
            display: 'none',
            background: 'none',
            border: 'none',
            color: 'var(--text-primary)',
            cursor: 'pointer',
          }}
          className="mobile-toggle"
        >
          {mobileOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div data-testid="nav-mobile-menu" className="animate-slide-down" style={{
          background: 'var(--dark-card)',
          borderBottom: '1px solid var(--dark-border)',
          padding: '16px 24px',
        }}>
          {navLinks.map(link => (
            <Link
              key={link.path}
              to={link.path}
              onClick={() => setMobileOpen(false)}
              style={{
                display: 'block',
                textDecoration: 'none',
                color: location.pathname === link.path ? 'var(--cyan)' : 'var(--text-secondary)',
                padding: '12px 0',
                fontSize: 15,
                fontWeight: 500,
                borderBottom: '1px solid var(--dark-border)',
              }}
            >
              {link.label}
            </Link>
          ))}
          <div style={{ display: 'flex', gap: 12, marginTop: 16 }}>
            <Link to="/sign-in" onClick={() => setMobileOpen(false)} className="btn-secondary" style={{
              textDecoration: 'none', flex: 1, textAlign: 'center',
              padding: '10px 16px', fontSize: 14,
            }}>Sign In</Link>
            <Link to="/get-started" onClick={() => setMobileOpen(false)} className="btn-primary" style={{
              textDecoration: 'none', flex: 1, textAlign: 'center',
              padding: '10px 16px', fontSize: 14,
            }}>Get Started</Link>
          </div>
        </div>
      )}

      <style>{`
        @media (max-width: 768px) {
          .desktop-nav { display: none !important; }
          .mobile-toggle { display: block !important; }
        }
      `}</style>
    </nav>
  );
};

export default Navbar;
